// extracted by mini-css-extract-plugin
export default {"container":"whyUs_container__3Is0k","row":"whyUs_row__GYbPW","col1":"whyUs_col1__VPELh","col2":"whyUs_col2__Ibr-h","col3":"whyUs_col3__GltBL","icon":"whyUs_icon__qN0fb"};